<template>
  <b-nav vertical class="sub-menu">
    <b-nav-item :to="{ name: 'cabinet_chat' }">
      {{ $t(`cabinet.blocks.chat.${currentParish.titles.chat}`) }}
    </b-nav-item>
    <b-nav-item :to="{ name: 'cabinet_conference' }">
      {{ $t(`cabinet.blocks.conference.${currentParish.titles.conference}`) }}
    </b-nav-item>
    <b-nav-item :to="{ name: 'cabinet_blog' }">
      {{ $t(`cabinet.blocks.blog.${currentParish.titles.blog}`) }}
    </b-nav-item>
    <b-nav-item >
      {{ $t(`cabinet.blocks.life.${currentParish.titles.life}`) }}
    </b-nav-item>
    <b-nav-item :to="{ name: 'cabinet_shrift' }">
      {{ $t(`cabinet.blocks.shrift.${currentParish.titles.shrift}`) }}
    </b-nav-item>
    <b-nav-item :to="{ name: 'cabinet_donations' }">
      {{ $t(`cabinet.blocks.donations.${currentParish.titles.donations}`) }}
    </b-nav-item>
  </b-nav>
</template>

<script>
export default {
  data: () => ({}),
  computed: {
    currentParish () {
      return this.$store.getters['ParishModule/currentParish']
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-menu {
  li {
    margin-bottom: .2rem;
    a {
      // background-color:
      color: rgb(113, 98, 111);

      border: none;
      border-bottom: 2px solid transparent;

      margin: .5rem 1rem;
      padding: 0;

      display: inline-block;

      &:hover {
        /*background-color: rgba(128, 109, 101, .2);*/
        border-bottom-color: #806d65;
      }

      &.router-link-active {
        /*background-color: rgba(128, 109, 101, .2);*/
        font-weight: bold;
        background-color: inherit;

        color: #565270;
        border-bottom-color: #565270;
      }
    }
  }
}
</style>
